import React from 'react'
import { FilterForm } from '@/components/filters/FilterForm'

import { MultiSelect } from '@/components/forms/MultiSelect'
import { DateRangePickerReusable } from '@/components/datePickers/DateRangePickerReusable'
import { FormField } from '@/components/forms/FormField'

export const PromptFeedbackFilters = ({
  startDate,
  endDate,
  onDateRangeChange,
  selectedOrgIds,
  onOrgChange,
  orgOptions,
  selectedScorecardIds,
  onScorecardChange,
  scorecardOptions,
  showOrgFilter = true,
}) => {
  return (
    <FilterForm small sticky={false}>
      <FormField>
        <label>Date Range</label>
        <DateRangePickerReusable
          data-testid="date-range-picker"
          onChange={onDateRangeChange}
          startDate={startDate}
          endDate={endDate}
        />
      </FormField>
      {showOrgFilter && (
        <FormField data-testid="organization-dropdown">
          <label>Organizations</label>
          <MultiSelect
            placeholder="All Organizations"
            value={selectedOrgIds}
            onChange={onOrgChange}
            options={orgOptions}
          />
        </FormField>
      )}
      <FormField data-testid="scorecard-dropdown">
        <label>Scorecards</label>
        <MultiSelect
          placeholder="All Scorecards"
          value={selectedScorecardIds}
          onChange={onScorecardChange}
          options={scorecardOptions}
        />
      </FormField>
    </FilterForm>
  )
}
